document.addEventListener("turbo:load", function(){
  $('[data-toggle="tooltip"]').tooltip()
  $('.modal.start-open').modal('show')
});

document.addEventListener("turbo:before-cache", function() {
  $('.tooltip.show').remove()
});
